<template>
  <div>
    <v-switch
      v-model="showOverdueOnLogin"
      label="Show Overdue Alerts on Login"
      @change="toggleOverdueAlerts"
      class="mr-2"
      dense
      :color="color"
      :label-color="switchTextColor"
      hide-details
      style="min-width: 220px"
    />
    <overdue-alert
      :show="showOverdueAlert"
      :overdueAlertData="overdueAlertData"
      :overdueMaxData="overdueMaxData"
      :refType="refType"
      :subRefTypes="subRefTypes"
      :branch="branch"
      :stages="stages"
      :currentUser="currentUser"
      @close="showOverdueAlert = false"
    />
  </div>
</template>

<script>
import OverdueAlert from "./OverdueAlert.vue";

export default {
  name: "OverdueAlertToggle",
  components: { OverdueAlert },
  props: {
    overdueAlertData: { type: Array, required: true },
    overdueMaxData: { type: Array, required: true },
    refType: { type: Array, required: true },
    subRefTypes: { type: Array, required: true },
    branch: { type: Array, required: true },
    stages: { type: Array, required: true },
    currentUser: { type: Object, required: true },
    color: { type: String, default: "primary" },
    switchTextColor: { type: String, default: "primary" },
  },
  data() {
    return {
      showOverdueOnLogin: false,
      showOverdueAlert: false,
    };
  },
  watch: {
    overdueAlertData: {
      immediate: true,
      handler() {
        this.checkShowAlert();
      },
    },
    overdueMaxData: {
      immediate: true,
      handler() {
        this.checkShowAlert();
      },
    },
  },
  mounted() {
    // Initialize from localStorage
    const showAlerts = localStorage.getItem("showOverdueAlerts");
    this.showOverdueOnLogin = showAlerts === null || showAlerts === "true";
    this.checkShowAlert();
  },
  methods: {
    toggleOverdueAlerts(value) {
      localStorage.setItem("showOverdueAlerts", value);
      this.showOverdueOnLogin = value;
      if (value) {
        this.checkShowAlert();
      } else {
        this.showOverdueAlert = false;
      }
    },
    checkShowAlert() {
      // Show alert if enabled and there are overdue items
      if (
        this.showOverdueOnLogin &&
        (this.overdueAlertData.length > 0 || this.overdueMaxData.length > 0)
      ) {
        this.showOverdueAlert = true;
      } else {
        this.showOverdueAlert = false;
      }
    },
  },
};
</script>
